import Price, { formatPrice } from "components/Price/Price"
import LabelSale from "components/Product/LabelSale"
import ProductPrice from "components/Product/ProductPrice"
import _ from "lodash"
import { observer } from "mobx-react"
import React, { Fragment } from "react"
import { Component, useEffect, useRef, useState } from "react"
import { Button, Table, Form, Icon, Input, Label, Segment, Image, Tab, Responsive } from "semantic-ui-react"
import shop from "shop/shop"
import ReactHover,{ Trigger, Hover } from "react-hover"
import "style/OrderTable.scss"
import settingStore from "stores/settingStore"
import ordinals from "theme/arnoldsports/sortParamsVariant"
import { Link } from "react-router-dom/cjs/react-router-dom.min"

const PRIMARY = "attr2"
const SECONDARY = "attr1"
let isHovering = false
const options = {
	followCursor: true,
	shiftX: 20,
	shiftY: 0,
  }


@observer
export default class OrderTable extends Component {

	constructor(props) {
		super(props);
		this.state = {
			quantity: 0,
			byProduct: {},
			noteByProduct: {},
			loading: false,
			setIsShown: false,
			hover: false,
			testVariable: false,
			selectedSize: false,
			selectedColor: false,
		}
	}


	handleChange = ( variant, hash, value ) => {
		const {byProduct, noteByProduct} = this.state
		let ok = variant.validateCount( value )
		// let okNext = variant.validateCount( 1 + Number( value ) )
		// next addition will trigger max stock amount
		if ( !ok ) {
			noteByProduct[hash] = translate( "maximale Abnahme-Menge erreicht." )
		} else {
			delete noteByProduct[hash]
		}
		this.setState( {noteByProduct} )
		// current addition will trigger max stock
		if ( !ok ) return

		byProduct[hash] = value
		this.setState( {byProduct} )
		this.computeQuantity()
		this.calculateTotal()
	}

	mergeProductsWithCart() {
		const {byAttribute, variantMap} = this.props
		const firstDimension = byAttribute[PRIMARY]
		const secondDimension = byAttribute[SECONDARY]
		if(!firstDimension || !secondDimension){
			return
		}
		const firstKeys = Object.keys( firstDimension )
		const secondKeys = Object.keys( secondDimension )
		const {byProduct} = this.state

		firstKeys.forEach( firstKey => {
			secondKeys.forEach( secondKey => {
				const hash = `${firstKey}___${secondKey}`
				const variant = variantMap[hash]
				const inCart = variant && shop.cart.productsById.get( variant.map_id )
				if ( inCart && byProduct[hash] === undefined ) {
					byProduct[hash] = inCart.count
				}
			} )
		} )
		return byProduct
	}


	componentWillMount() {
		const {byAttribute, variantMap} = this.props
		if(!byAttribute) return
		//console.log("byAttribute: ", byAttribute)
		const firstDimension = byAttribute[PRIMARY]
		const secondDimension = byAttribute[SECONDARY]
		if(!firstDimension || !secondDimension){
			return
		}
		function isLetter( str ) {
			return str.length === 1 && str.match( /[a-z]/i );
		}

		if(!firstDimension) return

		let firstKeys = Object.keys( firstDimension )
		const secondKeys = _.sortBy( Object.keys( secondDimension ), item => {
			let ordinal = ordinals[item]
			if ( ordinal ) return ordinal

			if ( isLetter( item[0] ) ) {
				return item
			} else {
				return parseInt( item )
			}
		} )
		const byProduct = this.mergeProductsWithCart()

		// const products = [...shop.cart.productsById.entries()].map( a => a[1] ).filter( product => {
		// 	return product.mainart === this.props.product.mainart
		// } )

		// FILTER EMPTY SETS

		this.setState( {firstKeys, secondKeys, byProduct} )
	}

	componentWillUnmount() {
		//console.log( "UNMOUNT", this.state.byProduct , this.state.firstKeys, this.state.secondKeys )
		this.setState( {byProduct: {}} )
		this.setState({ firstKeys: [], secondKeys: [] });
	}

	computeQuantity() {
		const quantity = _.reduce( this.state.byProduct, ( a, b ) => {
			return Number( a ) + Number( b )
		}, 0 )
		this.setState( {quantity} )
	}

	calculateTotal() {
		const {variantMap} = this.props
		const {byProduct} = this.state
		let sum = 0
		_.map( byProduct, ( quantity, hash ) => {
			const product = variantMap[hash]
			if ( product ) {
				let price = 0
				if (product.prices) {
					console.log("product.prices: ", product.prices)
					for (let i = product.prices.length - 1; i >= 0; i--) {
						if (quantity >= product.prices[i].q) {
							price = quantity * product.prices[i].p * product.unit_multi;
							break;
						}
						else {
							price = quantity * product.price * product.unit_multi;
						}
					}
				} else {
					price = quantity * product.price * product.unit_multi;
				}
				//let price = quantity * product.price * product.unit_multi
				sum += price
			}
		} )
		return sum
	}

	handleSubmit = () => {
		this.setState( {loading: true} )
		const {quantity} = this.state
		const {variantMap} = this.props
		const sum = this.calculateTotal()
		let positionCount = 0
		const {byProduct} = this.state
		_.map( byProduct, ( quantity, hash ) => {
			const product = variantMap[hash]
			console.log( {quantity, hash} )
			if ( product ) {
				positionCount++
				product.count = quantity
				shop.cart.add( product )
			}
		} )
		//<div class="f6 ttu">${positionCount} Positionen ( ${formatPrice( sum )} € )  ${this.props.product.extraValue.stamm_art}</div>
		setTimeout( () => {
				this.setState( {loading: false} )
				if(shop.session && shop.session.shopuser && !shop.session.shopuser.guest){
					shop.toast( `<div>
						<div>Warenkorb aktualisiert</div>
						<div class="f6 ttu">${positionCount} Positionen ( ${formatPrice( sum )} € ) </div>
						</div>`, "info", false, "top" )
				}
				else{
					shop.toast( `<div>
						<div>Warenkorb aktualisiert</div>
						<div class="f6 ttu">${positionCount} Positionen  </div>
						</div>`, "info", false, "top" )
						shop.whoami()
				}

				console.log( "ADD:CART:ORDERTABLE", {byProduct} )
			}, 520
		)

	}

	onLeave = () => {
		isHovering = false
		this.setState( { hover: false } )
		window.setTimeout( () => {
		  let { hover } = this.state
		  if ( !hover ) this.setState( { index: false } )
		}, 120 )
	  }

	onHover = () => {
		const DELAY = 300
		isHovering = true
		window.setTimeout( () => {
		  if ( isHovering ) this.setState( {hover: true } )
		}, DELAY )
	  }

	  cleanUpMount = () => {
		//console.log("this.props CLEANUPMOUNT: ", this.props)
		const {byAttribute, variantMap} = this.props
		if(!byAttribute) return
		//console.log("byAttribute: ", byAttribute)
		const firstDimension = byAttribute[PRIMARY]
		const secondDimension = byAttribute[SECONDARY]
		if(!firstDimension || !secondDimension){
			return
		}
		function isLetter( str ) {
			return str.length === 1 && str.match( /[a-z]/i );
		}

		if(!firstDimension) return

		let firstKeys = Object.keys( firstDimension )
		const secondKeys = _.sortBy( Object.keys( secondDimension ), item => {
			let ordinal = ordinals[item]
			if ( ordinal ) return ordinal

			if ( isLetter( item[0] ) ) {
				return item
			} else {
				return parseInt( item )
			}
		} )
		const byProduct = this.mergeProductsWithCart()

		// const products = [...shop.cart.productsById.entries()].map( a => a[1] ).filter( product => {
		// 	return product.mainart === this.props.product.mainart
		// } )

		// FILTER EMPTY SETS

		this.setState( {firstKeys, secondKeys, byProduct} )
	  }

	  useEffect = async () => {
		// Update the document title using the browser API
		//console.log("this.props useEffect")
		//console.log("this.props CLEANUPMOUNT: ", this.props)
		const {byAttribute, variantMap} = this.props
		this.setState({selectedColor: false, selectedSize: false})
		if(!byAttribute) return
		//console.log("byAttribute: ", byAttribute)
		const firstDimension = byAttribute[PRIMARY]
		const secondDimension = byAttribute[SECONDARY]
		if(!firstDimension || !secondDimension){
			return
		}
		function isLetter( str ) {
			return str.length === 1 && str.match( /[a-z]/i );
		}

		if(!firstDimension) return

		let firstKeys = Object.keys( firstDimension )
		const secondKeys = _.sortBy( Object.keys( secondDimension ), item => {
			let ordinal = ordinals[item]
			if ( ordinal ) return ordinal

			if ( isLetter( item[0] ) ) {
				return item
			} else {
				return parseInt( item )
			}
		} )
		const byProduct = this.mergeProductsWithCart()

		// const products = [...shop.cart.productsById.entries()].map( a => a[1] ).filter( product => {
		// 	return product.mainart === this.props.product.mainart
		// } )

		// FILTER EMPTY SETS

		this.setState( {firstKeys, secondKeys, byProduct} )
		};

	render() {
		const myRef = useRef<HTMLElement | null>(null);
		if(this.state.selectedColor && this.state.selectedSize){
			const element = document.getElementById('my-section');
										if ( !element ) return;
										window.scroll({
											top: element.offsetTop - 50,
											behavior: 'smooth'
										})
		}
		const {loading, secondKeys, firstKeys, noteByProduct,setIsShown,hover} = this.state
		const {byAttribute, variantMap, variantProtoypeByKey, product,isToggle} = this.props
		//console.log("this.props ORDERTABLE: ", product, byAttribute, variantMap, variantProtoypeByKey)
		const isToggleOrderTable = isToggle
		const byProduct = this.mergeProductsWithCart()
		//console.log("this.props byAttribute: ", Object.keys(byAttribute.attr1), Object.keys(byAttribute.attr2));
		//console.log("this.props Keys: ", secondKeys, firstKeys)
		if(Object.keys(byAttribute.attr2).toString() !== firstKeys.toString()){
			//console.log("this.props nicht gleich: ", Object.keys(byAttribute.attr1).toString(), secondKeys.toString());
			this.setState({selectedColor: false, selectedSize: false})
			//console.log("this.props selectedColor: ", this.state.selectedColor, this.state.selectedSize)	
			this.useEffect()
			return <Segment loading/>
		}
		const {productsById} = shop.cart
		if ( !byAttribute ) return <Segment loading/>
		let countByColumn = {}
		const sum = this.calculateTotal()
		if(!secondKeys || !firstKeys){
			return <div></div>
		}
		if((secondKeys && secondKeys[0] === "undefined") || (firstKeys && firstKeys[0] === "undefined")){
			return <div></div>
		}
		//console.log("PRE RETURN this.props selectedColor: ", this.state.selectedColor, this.state.selectedSize, "KEYS: ", secondKeys, firstKeys)	
		return <Fragment>
			<Responsive minWidth={790}>
			<div className="OrderTable" style={{zIndex: 120}}>
			<Form style={{zIndex: 190}} onSubmit={this.handleSubmit}>

				<Table style={{zIndex: 190}} basic="very" compact>
	<Table.Body>
		<Table.Row>
			<Table.Cell width={"10%"}>
				<strong>{product.desc.short_des.split( "," )[0]}</strong>
			</Table.Cell>
			{secondKeys.map( key => {
				if (key === undefined || key === "undefined") {
					return false;
				}
				//console.log("key ", key," product.extras.attr1 ", product.extras, " attr2: ",product.extras)
				if (product.extras && product.extras.attr1 && key != product.extras.attr1.value.value) {
					return <Table.Cell  textAlign="center"
													 key={key}><div className="pl6">{key === "null" ? "uni" : key.startsWith("V") ? "" : key}</div> </Table.Cell>
				}
				return <Table.Cell  textAlign="center"
													 key={key}><div className="pl6">{key === "null" ? "uni" : key.startsWith("V") ? "" : key}</div></Table.Cell>
			} )}
			<Table.Cell width={2} className="fixedElement" textAlign="right">
				<div className=" ">{translate( "Stück" )}</div>
				<div className="black-60 f6 ">{translate( "Preis" )}</div>
			</Table.Cell>
			
		</Table.Row>
		{firstKeys.map( firstKey => {

			let count = 0
			const size = secondKeys.length
			const isTiny = size > 100  // should display a very tiny ui b/c so many variants
			let variant = false
			const size2 = firstKeys.length
			//console.log("size? ",size, "size2",size2, " isTiny ",isTiny)
			if ( variantProtoypeByKey[PRIMARY] && variantProtoypeByKey[PRIMARY][firstKey] ) {
				variant = variantProtoypeByKey[PRIMARY][firstKey]
			}
			return <Table.Row key={firstKey}>
				<Table.Cell width={1}>
					<div className={`flex ${isTiny ? "flex-column" : "flex-row"}`}>
						<div className="pr1 mw3 w-100">
							<div className="img-container">
								{variant && <Link to={`/product/${variant.map_id}`}><Image style={{maxWidth: "80px",maxHeight: "80px", minWidth: "80px",minHeight: "80px", overflow: "hidden",objectFit: "contain"}} className={"OrderTableImage"} centered src={variant.img_src_small}/></Link>}
							</div>
						</div>
						<div className="pl4">
							<div className="f6"><Link to={`/product/${variant.map_id}`}></Link></div>
							{size2 > 1 && <div className="f6 black-60"> {firstKey === "null" ? "uni" : firstKey}</div>}
							{variant.isSale && <LabelSale price={variant.originalPrice} percent={variant.salePercent}/>}
							{/*<span className="black"><Price>{variant.price}</Price></span>*/}
						</div>
					</div>

				</Table.Cell>
				{secondKeys.map( ( secondKey, index ) => {
					const hash = `${secondKey}___${firstKey}`
					const variant = variantMap[hash]
					//console.log("byAttribute :", hash)
					//console.log("byAttribute :", variantMap)
					const inCart = variant && shop.cart.productsById.get( variant.map_id )
					//console.log("byAttribute kommen wir hier rein?", hash)
					//console.log("byAttribute kommen wir hier rein?", variantMap)
					let addCount = variant && Number( byProduct[hash] ) || 0
					let verticalCount = countByColumn[index] || 0
					verticalCount += addCount
					countByColumn[index] = verticalCount
					if ( variant ) {
						const disabled = !variant.available
						if ( disabled ) {
							return <Table.Cell align="center" key={secondKey}>
								<div className="relative mw4 center">
									{/*<Input className="" disabled/>*/}
									{/*<div className={" tc  black-60 f7  bg-silver"}>*/}
									{/*  -*/}
									{/*</div>*/}
									<div className="tc black-20"><Icon name="close"/></div>
								</div>
							</Table.Cell>
						}

						count += Number( addCount )
						let productCount = ( byProduct[hash] !== undefined ) ? addCount : 0
						if ( productCount === undefined && inCart ) productCount = inCart.count
						if ( productCount === undefined ) productCount = 0
						
						return <Table.Cell align="center" className="relative" key={secondKey}>
							<div className={`OrderMatrixCell center w-100 flex flex-column ${isTiny ? "tiny" : "regular"} `}>
							<table className="w-100">
								<tbody>
								<tr>
									<td>
									<table>
										<tbody>
										{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && variant.price && <tr className="tr" >
												<td className="f7">{translate("ab")}</td>
												<td className="f7 tr">1</td>
												<td className="f7 tr">{variant.price.toFixed(2).replace(".",",")}€</td>
											</tr>}
										{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && variant.prices && variant.prices.map( price => (
											<tr className="tr" key={price.q}>
												<td className="f7">{translate("ab")}</td>
												<td className="f7 tr">{price.q} </td>
												<td className="f7 tr">{price.p.toFixed(2).replace(".",",")}€</td>
											</tr>
										) )}
										</tbody>
									</table>
										</td>
									<td className="tr">
									<Input type="number" min={Number(variant.pinfos.minbuy) != 0 ? Number(variant.pinfos.minbuy) : 1} placeholder="1" 
						  defaultValue={Number(variant.pinfos.minbuy) != 0 ? Number(variant.pinfos.minbuy) : variant.count} action  className="w-100 "
											 step={variant.unit_multi}
											 onBlur={e => {
												if (Number(e.target.value) < Number(variant.pinfos.minbuy)) {
													shop.toast(translate(`Mindestbestellmenge wurde korrigiert.`), "warning", false, "top");
													e.target.value = Number(variant.pinfos.minbuy);
													this.setState({ count: e.target.value });
													  
												  }
												 let count = Math.ceil( e.target.value / variant.unit_multi )
												 this.handleChange( variant, hash, count )
											 }}
											 onChange={e => {
												 let count = Math.ceil( e.target.value / variant.unit_multi )
												 this.handleChange( variant, hash, count, )
											 }}>

									<input type="number" min="0" className="tr"/>
								</Input>
								{/*{inCart && <div className="absolute right-0 bottom-1 f7 black-60 bg-white pointer-events-none"><Label size={"tiny"} circular color="green"><Icon name={"shopping cart"}/></Label></div>}*/}
								
								<MetaBar className="" product={variant} inCart={inCart} note={noteByProduct[hash]}/>
								<div className="pt1 pb1">
									<Button title={`Zum Produkt`} as={Link} to={`/product/`+variant.map_id}  className=" w-100 centerflex flex-column f7"
									primary>
										{translate( "Details" )}
									</Button>
								</div>
										</td>
								</tr>
								</tbody>
							</table>

							</div>
							<div className="pt1">
							{/*isToggle &&<Button title={`Zum Produkt`} as={Link} to={`/product/`+variant.map_id} onClick={() => document.location.reload()} className="center w-100 flex flex-column" secondary>
							<Icon className="center w-100 flex flex-column large arrow alternate circle right"></Icon>
											</Button>*/}
							{/*!isToggle && <Button title={`Zum Produkt`} as={Link} to={`/product/`+variant.map_id}  className="center w-100 flex flex-column" secondary>
								<Icon title={`Zum Produkt`} className="center w-100 flex flex-column large arrow alternate circle right"></Icon>
											</Button>*/}
						</div></Table.Cell>
					}

					if ( !variant ) return <Table.Cell className="MetaBar" textAlign="center" key={secondKey}>
						<div className="relative">
							<div className="relative mw4 center">
								{/*<Input className="" disabled/>*/}
								{/*<div className={" tc  black-60 f7  bg-silver"}>*/}
								{/*  -*/}
								{/*</div>*/}
								<div className="tc black-20"><Icon name="close"/></div>
							</div>
						</div>
					</Table.Cell>
				} )}
				<Table.Cell textAlign="right">
					<div>    {count && count || 0}</div>
					{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <div className="f6 black-60"><Price>{sum || 0}</Price>
					</div>}
				</Table.Cell>
			</Table.Row>
		} )}
		<Table.Row>
			<Table.Cell>
				<div>{translate( "Anzahl" )}</div>
				<div className="f7 tc ">&nbsp;</div>
			</Table.Cell>
			{secondKeys.map( ( key, index ) => {
				if(key != product.extras.attr1.value.value){
					return <Table.Cell textAlign="center" key={key}>{countByColumn[index] || 0}</Table.Cell>
				}
				return <Table.Cell textAlign="center" key={key}>{countByColumn[index] || 0}</Table.Cell>
			} )}

			<Table.Cell textAlign="right">
				<div className="b f4">
					{
						_.reduce( byProduct, ( acc, value ) => {
							return acc + Number( value )
						}, 0 )
					}
				</div>
			</Table.Cell>
		</Table.Row>
		</Table.Body>
		</Table>
		<Button loading={loading} disabled={loading} floated="right" color={"black"}><span
			className={"ttu"}><Icon
			name={"shopping cart"}/> {translate( "Aktualisieren" )} </span></Button>
		</Form>
		</div>
		</Responsive>
		<Responsive maxWidth={789}>
		<h2 className="b bb b--black-20 pa2">Varianten wählen</h2>
		<div className="variance-dropdown">
			<Form>
				<Form.Field>
					<label>{translate("Farbe")}</label>
					<select onChange={(e) => this.setState({ selectedSize: e.target.value })} value={firstKeys.length === 1 ? firstKeys[0] : this.state.selectedSize}>
						<option value="">{translate("Farbe wählen")}</option>
						{firstKeys.map(size => (
							<option key={size} value={size}>{size.startsWith("V") ? "Standard" : size}</option>
						))}
					</select>
				</Form.Field>
				<Form.Field>
					<label>{translate("Größe")}</label>
					<select onChange={(e) => this.setState({ selectedColor: e.target.value })} value={secondKeys.length === 1 ? secondKeys[0] : this.state.selectedColor}>
						<option value="">{translate("Größe wählen")}</option>
						{secondKeys.map(color => (
							<option key={color} value={color}>{color.startsWith("V") ? "Standard" : color}</option>
						))}
					</select>
				</Form.Field>
			</Form>
			
			{firstKeys.length === 1 && !this.state.selectedSize && this.setState({ selectedSize: firstKeys[0] })}
			{secondKeys.length === 1 && !this.state.selectedColor && this.setState({ selectedColor: secondKeys[0] })}
			{this.state.selectedSize && this.state.selectedColor && ( <Fragment>
				<div className="pt3 pb3">
				<strong className="pb2">{product.desc.short_des.split( "," )[0]}</strong>
				<table >
					<colgroup>
						<col width="30%"/>
						<col width="30%"/>
						<col width="30%"/>
					</colgroup>
					<tbody>
						<tr>
							<td className="bb b--black-20">
							{variantProtoypeByKey[PRIMARY] && variantProtoypeByKey[PRIMARY][this.state.selectedSize] && (
												<Link to={`/product/${variantProtoypeByKey[PRIMARY][this.state.selectedSize].map_id}`}>
													<Image style={{ maxWidth: "80px", maxHeight: "80px", minWidth: "80px", minHeight: "80px", overflow: "hidden", objectFit: "contain" }} className={"OrderTableImage"} centered src={variantProtoypeByKey[PRIMARY][this.state.selectedSize].img_src_small} />
												</Link>
											)}
							</td>
							<td className="w-20 tr pt2 pl2 pr2 pb2 b bb b--black-10 f7">{shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<div className="bb b--black-20">{translate("ab  ")}{"1  "}{variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].price.toFixed(2).replace(".", ",")}€</div>}
							{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].prices && variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].prices.map(price => (
									<div className="bb b--black-20" key={price.q}><Fragment key={price.q}>{translate("ab  ")}{price.q}{"  "}{price.p.toFixed(2).replace(".", ",")}€</Fragment></div>
								))}
								</td>
							<td className="bb b--black-20 pl3 pb2 pt2 pr3">
								{/*console.log("this.props selectedColor: ", this.state.selectedColor, this.state.selectedSize, Number(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].pinfos.minbuy))*/}
							<Input className="w-100 input-with-buttons" 
							min={Number(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].pinfos.minbuy) != 0 ? Number(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].pinfos.minbuy) : 1} placeholder="1" 
							defaultValue={Number(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].pinfos.minbuy) != 0 ? Number(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].pinfos.minbuy) : variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].count} action
										step={variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`] ? variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].unit_multi : variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`]}
										onBlur={e => {
											if (Number(e.target.value) < Number(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].pinfos.minbuy)) {
												shop.toast(translate(`Mindestbestellmenge wurde korrigiert.`), "warning", false, "top");
												e.target.value = Number(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].pinfos.minbuy);
												this.setState({ count: e.target.value });
											}
											let count = Math.ceil(e.target.value / variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].unit_multi)
											this.handleChange(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`], `${this.state.selectedColor}___${this.state.selectedSize}`, count)
										}}
										onChange={e => {
											let count = Math.ceil(e.target.value / variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].unit_multi)
											this.handleChange(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`], `${this.state.selectedColor}___${this.state.selectedSize}`, count)
										}}>
										<input type="number" min="0" className="tr" autoFocus={this.state.selectedColor && this.state.selectedSize} />
									</Input>
									<MetaBar product={variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`]} inCart={shop.cart.productsById.get(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`]) ? shop.cart.productsById.get(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`]).map_id : shop.cart.productsById.get(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`])} note={noteByProduct[`${this.state.selectedColor}___${this.state.selectedSize}`]} />
									<div className="pt1 pb1"></div>
											<div className="pt1 pb1">
												<Button title={`Zum Produkt`} as={Link} to={`/product/${variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`] ? variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].map_id : variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`]}`} className="w-100 center flex flex-column f7" primary>
													{translate("Details")}
												</Button>
											</div>
									</td>
								</tr>
							</tbody>
						</table></div>
						<Table basic="very" compact>
							<Table.Body>

								{/*<Table.Row>
<div>
									<td className="pt2 pb2">
									{variantProtoypeByKey[PRIMARY] && variantProtoypeByKey[PRIMARY][this.state.selectedSize] && (
														<Link to={`/product/${variantProtoypeByKey[PRIMARY][this.state.selectedSize].map_id}`}>
															<Image style={{ maxWidth: "80px", maxHeight: "80px", minWidth: "80px", minHeight: "80px", overflow: "hidden", objectFit: "contain" }} className={"OrderTableImage"} centered src={variantProtoypeByKey[PRIMARY][this.state.selectedSize].img_src_small} />
														</Link>
													)}
									</td>
										<td style={{paddingLeft: "120px", paddingTop: "25px"}} className="w-100 tr pt2 b bb b--black-20 f7"><div><td className="w-100 tr">{translate("ab  ")}{"1  "}{variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].price.toFixed(2).replace(".", ",")}€</td></div>
																				{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].prices && va</div>riantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].prices.map(price => (
											<div key={price.q}><Fragment key={price.q}><td className="w-100 tr pt2 b bb b--black-20 f7">{translate("ab  ")}{price.q}{"  "}{price.p.toFixed(2).replace(".", ",")}€</td></Fragment></div>
										))}
										</td>
										<td style={{paddingRight: "90px", paddingTop: "20px"}} className="w-100 bb b--black-20 pt2 pb2 tr pr4 v-center">
										<Input className="w-100"
												step={variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`] ? variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].unit_multi : variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`]}
												value={Number((byProduct[`${this.state.selectedColor}___${this.state.selectedSize}`] || 0) * (variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`] ? variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].unit_multi : 0))}
												onBlur={e => {
													let count = Math.ceil(e.target.value / variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].unit_multi)
													this.handleChange(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`], `${this.state.selectedColor}___${this.state.selectedSize}`, count)
												}}
												onChange={e => {
													let count = Math.ceil(e.target.value / variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].unit_multi)
													this.handleChange(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`], `${this.state.selectedColor}___${this.state.selectedSize}`, count)
												}}>
												<input type="number" min="0" className="tr" />
											</Input>
											<MetaBar product={variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`]} inCart={shop.cart.productsById.get(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`]) ? shop.cart.productsById.get(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`]).map_id : shop.cart.productsById.get(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`])} note={noteByProduct[`${this.state.selectedColor}___${this.state.selectedSize}`]} />
											<div className="pt1 pb1">
												<Button title={`Zum Produkt`} as={Link} to={`/product/${variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`] ? variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].map_id : variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`]}`} className="w-100 center flex flex-column f7" primary>
													{translate("Details")}
												</Button>
											</div></td><br/>
										</div>
									{/*<Table.Cell align="center" className="relative">
										<div className="OrderMatrixCell center w-100 flex flex-column regular">
											<Input className="w-100"
												step={variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`] ? variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].unit_multi : variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`]}
												value={Number((byProduct[`${this.state.selectedColor}___${this.state.selectedSize}`] || 0) * (variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`] ? variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].unit_multi : 0))}
												onBlur={e => {
													let count = Math.ceil(e.target.value / variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].unit_multi)
													this.handleChange(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`], `${this.state.selectedColor}___${this.state.selectedSize}`, count)
												}}
												onChange={e => {
													let count = Math.ceil(e.target.value / variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].unit_multi)
													this.handleChange(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`], `${this.state.selectedColor}___${this.state.selectedSize}`, count)
												}}>
												<input type="number" min="0" className="tr" />
											</Input>
											<MetaBar product={variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`]} inCart={shop.cart.productsById.get(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`]) ? shop.cart.productsById.get(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`]).map_id : shop.cart.productsById.get(variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`])} note={noteByProduct[`${this.state.selectedColor}___${this.state.selectedSize}`]} />
											<div className="pt1 pb1">
												<Button title={`Zum Produkt`} as={Link} to={`/product/${variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`] ? variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`].map_id : variantMap[`${this.state.selectedColor}___${this.state.selectedSize}`]}`} className="w-100 center flex flex-column f7" primary>
													{translate("Details")}
												</Button>
											</div>
										</div>
									</Table.Cell>}*/}
									<Table.Row>
									<Table.Cell textAlign="right">
										<div>{byProduct[`${this.state.selectedColor}___${this.state.selectedSize}`] || 0}</div>
										{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <div className="f6 black-60"><Price>{sum || 0}</Price></div>}
									</Table.Cell>
									<section ref={myRef} id="my-section">
									</section>
								</Table.Row>
							</Table.Body>
						</Table></Fragment>
					)}
																{this.state.selectedSize && this.state.selectedColor &&<div className="w-100 pt2 pb1">
											<Button loading={loading} disabled={loading} onClick={this.handleSubmit} floated="right" color={"black"}><span
													className={"ttu"}><Icon
													name={"shopping cart"}/> {translate( "Aktualisieren" )} </span></Button>
											</div>}
				</div>
				</Responsive>
		</Fragment>
	}
}

const MetaBar = ( {product, inCart, note} ) => {
	let isVertreter = !!shop.session.handId
	const Note = product.getNotice( "tiny" )
	const cartCount = ( inCart && inCart.count ) ? inCart.count : 0
	const mode = settingStore.get( "orderMode" )
	let stock = product.stock
	let boxColor = null
	if ( !isVertreter ) {
		if ( stock >= 10 ) {
			stock = "10+"
		}
	}

	if ( stock >= 100 ) {
		stock = "99+"
	}

	if ( stock <= 0 ) {
		stock = false
	}

	if ( mode === "MODE_PREORDER" ) {
		stock = false
	}

	return <div className="MetaBar w-100">
		<div className={"flex f6 black-60 flex-column items-center justify-around ph2 "}>
			<div className=" " title={translate( "Menge verfügbar" )}>
				{note && <span><Icon name="warning circle" title={note}/></span>}
				{shop.session.handId && shop.session.handUser && shop.session.handUser.extras && shop.session.handUser.extras.stock && <span>{product.stock} verfügbar</span>}
				{product.extras && product.extras.Einlagerung && product.extras.Einlagerung.value.value && <span>{product.stock} verfügbar</span>}
			</div>
			{/*product.stock == 0 && <div><Icon title="Ausverkauft" className="red truck icon"></Icon></div>}
			{product.stock != 0 && product.stock <= 3 && <div><Icon title="Wenige auf Lager" className="yellow truck icon"></Icon></div>*/}
			{<div><Icon title="" className={`${product.extras.stockColor.value.value} truck icon`}></Icon></div>}
			{<div className={`db u-text-no-wrap ${!cartCount ? "black-30" : ""}`}>
				<span>{cartCount}&nbsp;<Icon title={`${cartCount} im Warenkorb`} name={"shopping cart"}/>
				</span>
				
			</div>}
		</div>
		{/*<Note/>*/}
	</div>
}
//


const StockCount = ( {stock, warn = 2, className = ""} ) => {
	if ( stock > warn ) {
		return <Label color={"green"} className={` ${className}`}>{stock}</Label>
	}
	if ( stock <= warn && stock >= 1 ) {
		return <Label color={"yellow"} className={` ${className}`}>{stock}</Label>
	}
	return <Label className={`black-60 ${className}`}>{stock}</Label>
}



// WEBPACK FOOTER //
// ./src/theme/hvz/components/OrderTable/OrderTable.js